import { render, staticRenderFns } from "./shoppingList.vue?vue&type=template&id=23764103&scoped=true&"
import script from "./shoppingList.vue?vue&type=script&lang=js&"
export * from "./shoppingList.vue?vue&type=script&lang=js&"
import style0 from "./shoppingList.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./shoppingList.vue?vue&type=style&index=1&id=23764103&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23764103",
  null
  
)

export default component.exports